export const bedroomNumber = (value) => {
  if (value === null || value === undefined || value === '' || typeof value === 'boolean') return null;
  const number = Number(value);
  return Number.isInteger(number) && number >= 0 ? number : null;
};

export const getBedroomOptions = (units) => [...new Set([
  0, 1, 2, 3, 4, 5,
  ...units.filter(unit => unit.unit_type === 'residential')
    .map(unit => bedroomNumber(unit.bedrooms)).filter(value => value !== null),
])].sort((a, b) => a - b);

export const matchesBedroomFilter = (unit, selectedBedrooms) => selectedBedrooms === 'all' || (
  unit.unit_type === 'residential' &&
  unit.status === 'available' &&
  !unit.is_rented &&
  bedroomNumber(unit.bedrooms) !== null &&
  bedroomNumber(unit.bedrooms) === Number(selectedBedrooms)
);